var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_294_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 294 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2622",
    "data-name": "\\uC0AC\\uAC01\\uD615 2622",
    width: 21.763,
    height: 21.763,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2625",
    "data-name": "\\uC0AC\\uAC01\\uD615 2625",
    width: 17.763,
    height: 17.763,
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4237",
    "data-name": "\\uADF8\\uB8F9 4237",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4230",
    "data-name": "\\uADF8\\uB8F9 4230",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4229",
    "data-name": "\\uADF8\\uB8F9 4229",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2621",
    "data-name": "\\uC0AC\\uAC01\\uD615 2621",
    width: 7.613,
    height: 7.613,
    transform: "translate(0.244 0.244)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2993",
    "data-name": "\\uD328\\uC2A4 2993",
    d: "M0,0H7.613V7.613H0Z",
    transform: "translate(9.905 0.244)",
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4232",
    "data-name": "\\uADF8\\uB8F9 4232",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4231",
    "data-name": "\\uADF8\\uB8F9 4231",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2624",
    "data-name": "\\uC0AC\\uAC01\\uD615 2624",
    width: 7.613,
    height: 7.613,
    transform: "translate(9.905 0.244)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2626",
    "data-name": "\\uC0AC\\uAC01\\uD615 2626",
    width: 7.613,
    height: 7.613,
    transform: "translate(0.244 9.905)",
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4234",
    "data-name": "\\uADF8\\uB8F9 4234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4233",
    "data-name": "\\uADF8\\uB8F9 4233",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2627",
    "data-name": "\\uC0AC\\uAC01\\uD615 2627",
    width: 7.613,
    height: 7.613,
    transform: "translate(0.244 9.905)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2992",
    "data-name": "\\uD328\\uC2A4 2992",
    d: "M0,0H7.613V7.613H0Z",
    transform: "translate(9.905 9.905)",
    fill: "none",
    stroke: "#b9bebe",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4236",
    "data-name": "\\uADF8\\uB8F9 4236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4235",
    "data-name": "\\uADF8\\uB8F9 4235",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2630",
    "data-name": "\\uC0AC\\uAC01\\uD615 2630",
    width: 7.613,
    height: 7.613,
    transform: "translate(9.905 9.905)",
    fill: "none",
    stroke: "#b9bebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2632",
    "data-name": "\\uC0AC\\uAC01\\uD615 2632",
    width: 24,
    height: 24,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCate);
export default __webpack_public_path__ + "static/media/icoCate.c68130e322f67e4949542a2873431db2.svg";
export { ForwardRef as ReactComponent };